import React from "react";

const LoadingLogoSpinner: React.FC = () =>
    <svg width="200" height="200" viewBox="0 0 390 390" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="scale(0.5) translate(195,195)">
            <path fillRule="evenodd" clipRule="evenodd" className="symbol"
                  d="M195 63.09C122.148 63.09 63.09 122.148 63.09 195C63.09 267.852 122.148 326.91 195 326.91C267.852 326.91 326.91 267.852 326.91 195C326.91 122.148 267.852 63.09 195 63.09ZM226.55 146.049L222.51 135.054C213.104 109.454 176.896 109.454 167.49 135.054L163.45 146.049C160.484 154.122 154.122 160.484 146.049 163.45L135.054 167.49C109.454 176.896 109.454 213.104 135.054 222.51L146.049 226.55C154.122 229.516 160.484 235.878 163.45 243.951L167.49 254.946C176.896 280.546 213.104 280.546 222.51 254.946L226.55 243.951C229.516 235.878 235.878 229.516 243.951 226.55L254.946 222.51C280.546 213.104 280.546 176.896 254.946 167.49L243.951 163.45C235.878 160.484 229.516 154.122 226.55 146.049Z"
                  fill="#4589FF">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    values="0 195 195;90 195 195"
                    keyTimes="0;1"
                    dur="0.75s"
                />
            </path>
        </g>
        <g transform="translate(195 195)">
            <circle cx="0" cy="0" r="120" stroke="#4589FF" strokeWidth="0">
                <animateTransform
                    attributeName="transform"
                    type="scale"
                    repeatCount="indefinite"

                    // values="0.5;0.5;0.7;1"
                    // keyTimes="0;0.5;0.8;1"

                    values="1.6;1.6;1.3;0.7"
                    keyTimes="0;0.6;0.7;1"

                    // values="1.6"
                    // values="0.5"

                    dur="2.25s"
                />
                <animate
                    attributeName="stroke-width"
                    values="0;0;3;3"
                    keyTimes="0;0.6;.85;1"
                    dur="2.25s"
                    repeatCount="indefinite"/>
                <animate
                    attributeName="stroke-opacity"
                    values="0;0;1;0.8;0"
                    keyTimes="0;0.6;0.7;0.85;1"
                    dur="2.25s"
                    repeatCount="indefinite"/>
            </circle>
        </g>
    </svg>
export default LoadingLogoSpinner
